export { default } from "./HistorialVentasSemana";
